import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Control, ControlType } from '../../../models/controls/control';
import { NgForm, NgModel, ValidatorFn, Validators } from '@angular/forms';
import { OrderService } from '../../../services/order/order.service';
import { DynamicFormService } from '../../../services/dynamic-form/dynamic-form.service';
import { Controller } from '../../../models/controls/controller';
import { Subscription } from 'rxjs';

const DoNotNotifyChange = { emitEvent: false };

@Component({
  selector: 'app-base-control',
  template: '',
})
export abstract class BaseControlComponent<T extends Control<any>>
  implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  form?: NgForm;

  @Input()
  control: T = new Control('', '', ControlType.text) as T;

  @ViewChild('name')
  ngModel?: NgModel;

  protected readonly validators: ValidatorFn[] = [];

  private controllers: Controller[] = [];

  private readonly listeners: Subscription[] = [];

  protected constructor(
    protected readonly orderService: OrderService,
    private readonly dynamicFormService: DynamicFormService
  ) {}

  ngOnInit(): void {
    this.controllers = this.dynamicFormService.getControllers(
      this.control.name
    );
  }

  ngAfterViewInit(): void {
    if (this.ngModel) {
      this.form?.addControl(this.ngModel);
      this.listeners.push(
        this.ngModel.control.valueChanges.subscribe((value) =>
          this.onValueChange(value)
        )
      );
      this.listeners.push(
        this.control.changed.subscribe(() => this.onControlChange())
      );
    }
  }

  protected onControlChange(): void {
    if (
      !this.control.required &&
      this.validators.indexOf(Validators.required) > -1
    ) {
      this.validators.splice(this.validators.indexOf(Validators.required), 1);
    }
    this.ngModel?.control.updateValueAndValidity(DoNotNotifyChange);
  }

  ngOnDestroy(): void {
    if (this.ngModel) {
      this.form?.removeControl(this.ngModel);
    }
    while (this.listeners.length > 0) {
      this.listeners.pop()?.unsubscribe();
    }
  }

  protected setValidators(): void {
    if (
      this.control.required &&
      this.validators.indexOf(Validators.required) === -1
    ) {
      this.validators.push(Validators.required);
    }
  }

  private onValueChange(value: string): void {
    this.control.value = value || this.control.value;
    if (this.ngModel?.control.valid && this.control.isVisible()) {
      this.orderService.store(this.control);
    } else {
      this.orderService.clear(this.control);
    }
    this.controllers.forEach((controller) =>
      controller.update(this.control.name, value)
    );
  }
}
